import { takeLatest, put, select } from 'redux-saga/effects';
import { createAxios } from '../utils/utils';
import {
  FORUM_LIST_72,
  FORUM_LIST_PUBLISH_72,
  FORUM_LIST_COLLECT_72,
  FORUM_ACTION_REMOVE_72,
  FORUM_ACTION_SET_72,
  FORUM_ASS_WORD_72,
  FORUM_UPLOAD_PARAMS_72,
  FORUM_INFO_72,
  FORUM_CONTENT_72,
  FORUM_SUBMIT_72,
  FORUM_DELETE_72,
  FORUM_COMMENT_ADD_72,
  FORUM_COMMENT_ZAN_72,
  FORUM_COMMENT_REVIEW_72,
  FORUM_COMMENT_LIST_72,
  FORUM_COMMENT_GRADE_72,
} from '../config';
import {
  FORUM_LIST_REQUEST,
  FORUM_LIST_PUBLISH_REQUEST,
  FORUM_LIST_COLLECT_REQUEST,
  FORUM_ACTION_REMOVE_REQUEST,
  FORUM_ACTION_SET_REQUEST,
  FORUM_ASS_WORD_REQUEST,
  FORUM_UPLOAD_PARAMS_REQUEST,
  FORUM_INFO_REQUEST,
  FORUM_CONTENT_REQUEST,
  FORUM_SUBMIT_REQUEST,
  FORUM_DELETE_REQUEST,
  FORUM_LIST_SUCCESS,
  FORUM_LIST_PUBLISH_SUCCESS,
  FORUM_LIST_COLLECT_SUCCESS,
  FORUM_ACTION_REMOVE_SUCCESS,
  FORUM_ACTION_SET_SUCCESS,
  FORUM_ASS_WORD_SUCCESS,
  FORUM_UPLOAD_PARAMS_SUCCESS,
  FORUM_INFO_SUCCESS,
  FORUM_CONTENT_SUCCESS,
  FORUM_SUBMIT_SUCCESS,
  FORUM_DELETE_SUCCESS,
  FORUM_COMMENT_ADD_REQUEST,
  FORUM_COMMENT_ZAN_REQUEST,
  FORUM_COMMENT_REVIEW_REQUEST,
  FORUM_COMMENT_LIST_REQUEST,
  FORUM_COMMENT_GRADE_REQUEST,
  FORUM_COMMENT_ADD_SUCCESS,
  FORUM_COMMENT_ZAN_SUCCESS,
  FORUM_COMMENT_REVIEW_SUCCESS,
  FORUM_COMMENT_LIST_SUCCESS,
  FORUM_COMMENT_GRADE_SUCCESS,
  FORUM_COMMENT_LOADING,
  FORUM_COMMENT_LIST_UPDATE,
} from '../constants/forum';

import Toast from '../components/Toast/Toast';

// 主页list
function* fetchForumList({ refresh }) {
  try {
    let skip = 0;
    const limit = 24;
    const forumList = yield select(state => state.forum.forumList);
    const axios = yield createAxios('isNeedUser');
    if (!refresh) {
      if (forumList.count > forumList.forumContentList.length) {
        skip = forumList.forumContentList.length;
      }
    } else {
      skip = 0;
    }
    const res = yield axios.get(FORUM_LIST_72, {
      params: { skip, limit },
    });
    // 第一次请求失败
    if (refresh && res.data.status !== 0) {
      yield put({
        type: FORUM_LIST_SUCCESS,
        payload: { loading: -1, refresh },
      });
      return;
    }
    if (refresh && res.data.status === 0 && res.data.data) {
      yield put({
        type: FORUM_LIST_SUCCESS,
        payload: { ...res.data.data, skip, limit, refresh },
      });
      return;
    }
    if (!refresh && res.data.status === 0 && res.data.data) {
      if (res.data.data.forumContentList && res.data.data.forumContentList.length === limit) {
        forumList.forumContentList = [
          ...forumList.forumContentList,
          ...res.data.data.forumContentList,
        ];
        forumList.count = forumList.forumContentList.length + 100;
      }
      if (res.data.data.forumContentList && res.data.data.forumContentList.length < limit) {
        forumList.forumContentList = [
          ...forumList.forumContentList,
          ...res.data.data.forumContentList,
        ];
        forumList.count = forumList.forumContentList.length;
      }
      yield put({
        type: FORUM_LIST_SUCCESS,
        payload: { ...forumList },
      });
    }
  } catch (error) {
    // 第一次请求失败
    yield put({
      type: FORUM_LIST_SUCCESS,
      payload: { loading: -1, refresh },
    });
  }
}
export function* watchForumList() {
  yield takeLatest(FORUM_LIST_REQUEST, fetchForumList);
}

// 我的发表
function* fetchForumListPub({ refresh }) {
  try {
    let skip = 0;
    const limit = 24;
    const forumListPub = yield select(state => state.forum.forumListPub);
    const axios = yield createAxios('isNeedUser');
    if (!refresh) {
      if (forumListPub.count > forumListPub.forumContentList.length) {
        skip = forumListPub.forumContentList.length;
      }
    } else {
      skip = 0;
    }
    const res = yield axios.get(FORUM_LIST_PUBLISH_72, {
      params: { skip, limit },
    });
    // 第一次请求失败
    if (refresh && res.data.status !== 0) {
      yield put({
        type: FORUM_LIST_PUBLISH_SUCCESS,
        payload: { loading: -1, refresh },
      });
      return;
    }
    if (refresh && res.data.status === 0 && res.data.data) {
      let count = 1000;
      if (res.data.data.forumContentList && res.data.data.forumContentList.length < limit) {
        count = res.data.data.forumContentList.length;
      } else {
        count = res.data.data.forumContentList.length + 100;
      }
      yield put({
        type: FORUM_LIST_PUBLISH_SUCCESS,
        payload: { ...res.data.data, skip, limit, refresh, count },
      });
      return;
    }
    if (!refresh && res.data.status === 0 && res.data.data) {
      if (res.data.data.forumContentList && res.data.data.forumContentList.length === limit) {
        forumListPub.forumContentList = [
          ...forumListPub.forumContentList,
          ...res.data.data.forumContentList,
        ];
        forumListPub.count = forumListPub.forumContentList.length + 100;
      }
      if (res.data.data.forumContentList && res.data.data.forumContentList.length < limit) {
        forumListPub.forumContentList = [
          ...forumListPub.forumContentList,
          ...res.data.data.forumContentList,
        ];
        forumListPub.count = forumListPub.forumContentList.length;
      }
      yield put({
        type: FORUM_LIST_PUBLISH_SUCCESS,
        payload: { ...forumListPub },
      });
    }
  } catch (error) {
    yield put({
      type: FORUM_LIST_PUBLISH_SUCCESS,
      payload: { loading: -2, refresh },
    });
  }
}
export function* watchForumListPub() {
  yield takeLatest(FORUM_LIST_PUBLISH_REQUEST, fetchForumListPub);
}

// 我的收藏
function* fetchForumListCol({ refresh }) {
  try {
    let skip = 0;
    const limit = 24;
    const forumListCol = yield select(state => state.forum.forumListCol);
    const axios = yield createAxios('isNeedUser');
    if (!refresh) {
      if (forumListCol.count > forumListCol.forumContentList.length) {
        skip = forumListCol.forumContentList.length;
      }
    } else {
      skip = 0;
    }
    const res = yield axios.get(FORUM_LIST_COLLECT_72, {
      params: { skip, limit },
    });
    // 第一次请求失败
    if (refresh && res.data.status !== 0) {
      yield put({
        type: FORUM_LIST_COLLECT_SUCCESS,
        payload: { loading: -1, refresh },
      });
      return;
    }
    if (refresh && res.data.status === 0 && res.data.data) {
      let count = 1000;
      if (res.data.data.forumContentList && res.data.data.forumContentList.length < limit) {
        count = res.data.data.forumContentList.length;
      } else {
        count = res.data.data.forumContentList.length + 100;
      }
      yield put({
        type: FORUM_LIST_COLLECT_SUCCESS,
        payload: { ...res.data.data, skip, limit, refresh, count },
      });
      return;
    }
    if (!refresh && res.data.status === 0 && res.data.data) {
      if (res.data.data.forumContentList && res.data.data.forumContentList.length === limit) {
        forumListCol.forumContentList = [
          ...forumListCol.forumContentList,
          ...res.data.data.forumContentList,
        ];
        forumListCol.count = forumListCol.forumContentList.length + 100;
      }
      if (res.data.data.forumContentList && res.data.data.forumContentList.length < limit) {
        forumListCol.forumContentList = [
          ...forumListCol.forumContentList,
          ...res.data.data.forumContentList,
        ];
        forumListCol.count = forumListCol.forumContentList.length;
      }
      yield put({
        type: FORUM_LIST_COLLECT_SUCCESS,
        payload: { ...forumListCol },
      });
    }
  } catch (error) {
    yield put({
      type: FORUM_LIST_COLLECT_SUCCESS,
      payload: { loading: -2, refresh },
    });
  }
}
export function* watchForumListCol() {
  yield takeLatest(FORUM_LIST_COLLECT_REQUEST, fetchForumListCol);
}

// 添加关联soft
function* fetchForumLenovoSoft(param) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(FORUM_ASS_WORD_72, {
      params: { word: param.word },
    });
    if (res.data.status === 0) {
      yield put({
        type: FORUM_ASS_WORD_SUCCESS,
        payload: { ...res.data, ...param },
      });
    }
  } catch (error) {}
}
export function* watchForumLenovoSoft() {
  yield takeLatest(FORUM_ASS_WORD_REQUEST, fetchForumLenovoSoft);
}

// 删除某一个帖子
function* fetchForumDelete(param) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(FORUM_DELETE_72, {
      params: { id: param.id },
    });
    if (res.data.status === 0) {
      yield put({
        type: FORUM_DELETE_SUCCESS,
        payload: { ...res.data, ...param },
      });
      Toast.success({ content: res.data.message });
    } else {
      Toast.success({ content: res.data.message });
    }
  } catch (error) {}
}
export function* watchForumDelete() {
  yield takeLatest(FORUM_DELETE_REQUEST, fetchForumDelete);
}

// 帖子基本详情
function* fetchForumDetail(param) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(FORUM_INFO_72, {
      params: { id: param.id },
    });
    if (res.data.status === 0 && res.data.data) {
      yield put({
        type: FORUM_INFO_SUCCESS,
        payload: { ...res.data.data },
      });
    }
  } catch (error) {}
}
export function* watchForumDetail() {
  yield takeLatest(FORUM_INFO_REQUEST, fetchForumDetail);
}

// 帖子更多详情
function* fetchForumDetailMore(param) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(FORUM_CONTENT_72, {
      params: { id: param.id },
    });
    if (res.data.status === 0 && res.data.data) {
      yield put({
        type: FORUM_CONTENT_SUCCESS,
        payload: { ...res.data.data },
      });
    }
    if (res.data.status === -2) {
      yield put({
        type: FORUM_CONTENT_SUCCESS,
        payload: { ...res.data, ...param },
      });
    }
  } catch (error) {}
}
export function* watchForumDetailMore() {
  yield takeLatest(FORUM_CONTENT_REQUEST, fetchForumDetailMore);
}

// 提交评论
function* fetchForumAddComment({ param }) {
  yield put({
    type: FORUM_COMMENT_ADD_SUCCESS,
    payload: { ...param, loading: true },
  });
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.post(FORUM_COMMENT_ADD_72, { ...param });
    if (res && res.data && res.data.status === 0) {
      Toast.success({ content: '评论发表成功' });
    } else {
      Toast.error({ content: (res.data && res.data.message) || '评论发表失败' });
    }
    if (res.data) {
      yield put({
        type: FORUM_COMMENT_ADD_SUCCESS,
        payload: { ...res.data, ...param, loading: false },
      });
    }
  } catch (error) {
    yield put({
      type: FORUM_COMMENT_ADD_SUCCESS,
      payload: { ...param, loading: false },
    });
    Toast.error({ content: '评论发表失败' });
  }
}
export function* watchForumAddComment() {
  yield takeLatest(FORUM_COMMENT_ADD_REQUEST, fetchForumAddComment);
}

// 提交评论回复
function* fetchForumAddReview({ param }) {
  yield put({
    type: FORUM_COMMENT_REVIEW_SUCCESS,
    payload: { ...param, loading: true },
  });
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.post(FORUM_COMMENT_REVIEW_72, { ...param });
    if (res.data.status === 0) {
      // 处理论坛详情详情页面的回复
      if (param.source !== 'message') {
        yield put({
          type: FORUM_COMMENT_LIST_UPDATE,
          payload: { ...res.data.data, ...param },
        });
      }
      Toast.success({ content: '评论发表成功' });
    } else {
      Toast.error({ content: (res.data && res.data.message) || '评论发表失败' });
    }
    if (res.data) {
      yield put({
        type: FORUM_COMMENT_REVIEW_SUCCESS,
        payload: { ...res.data, ...param, loading: false },
      });
    }
  } catch (error) {
    yield put({
      type: FORUM_COMMENT_REVIEW_SUCCESS,
      payload: { ...param, loading: false },
    });
    Toast.error({ content: '评论发表失败' });
  }
}
export function* watchForumAddReview() {
  yield takeLatest(FORUM_COMMENT_REVIEW_REQUEST, fetchForumAddReview);
}

// 加载评论列表
function* fetchForumCommentList({ param }) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.post(FORUM_COMMENT_LIST_72, param);
    yield put({
      type: FORUM_COMMENT_LOADING,
      payload: false,
    });
    if (res.data.status === 0 && res.data.data) {
      yield put({
        type: FORUM_COMMENT_LIST_SUCCESS,
        payload: {
          data: res.data.data,
          ...param,
        },
      });
    }
  } catch (error) {}
}
export function* watchForumCommentList() {
  yield takeLatest(FORUM_COMMENT_LIST_REQUEST, fetchForumCommentList);
}

// 点赞评论
function* fetchForumCommentZan({ param }) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.post(FORUM_COMMENT_ZAN_72, param);

    if (res.data.status === 0 && res.data.data) {
      yield put({
        type: FORUM_COMMENT_ZAN_SUCCESS,
        payload: {
          data: res.data.data,
          ...param,
        },
      });
      Toast.success({
        content: '点赞成功',
      });
    } else {
      Toast.error({ content: res.data.message || '点赞失败' });
    }
  } catch (error) {
    Toast.error({
      content: '点赞失败',
    });
  }
}
export function* watchForumCommentZan() {
  yield takeLatest(FORUM_COMMENT_ZAN_REQUEST, fetchForumCommentZan);
}

// 帖子点赞或者收藏
function* fetchForumActionSet({ param }) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(FORUM_ACTION_SET_72, { params: param });

    if (res.data.status === 0) {
      yield put({
        type: FORUM_ACTION_SET_SUCCESS,
        payload: {
          ...param,
        },
      });
      Toast.success({
        content: `${param.actionType === 1 ? '收藏' : '点赞'}成功`,
      });
    } else {
      Toast.error({
        content: `${param.actionType === 1 ? '收藏' : '点赞'}失败`,
      });
    }
  } catch (error) {
    Toast.error({
      content: `${param.actionType === 1 ? '收藏' : '点赞'}失败`,
    });
  }
}
export function* watchForumActionSet() {
  yield takeLatest(FORUM_ACTION_SET_REQUEST, fetchForumActionSet);
}

// 帖子取消点赞或者收藏
function* fetchForumActionRemove({ param }) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(FORUM_ACTION_REMOVE_72, { params: param });

    if (res.data.status === 0) {
      yield put({
        type: FORUM_ACTION_REMOVE_SUCCESS,
        payload: {
          ...param,
        },
      });
      Toast.success({
        content: `取消${param.actionType === 1 ? '收藏' : '点赞'}成功`,
      });
    } else {
      Toast.error({
        content: `取消${param.actionType === 1 ? '收藏' : '点赞'}失败`,
      });
    }
  } catch (error) {
    Toast.error({
      content: `取消${param.actionType === 1 ? '收藏' : '点赞'}失败`,
    });
  }
}
export function* watchForumActionRemove() {
  yield takeLatest(FORUM_ACTION_REMOVE_REQUEST, fetchForumActionRemove);
}
